import {filterByPriceOptions, productGroups} from '../constants';

const priceSuggestions = filterByPriceOptions.reduce((acc, option) => {
  const values = [];
  if (typeof option.range.min !== 'undefined') {
    values.push(`Above $${option.range.min}`, `Under $${option.range.min}`);
  }
  if (typeof option.range.max !== 'undefined') {
    values.push(`Above $${option.range.max}`, `Under $${option.range.max}`);
  }
  if (
    typeof option.range.min === 'undefined' ||
    typeof option.range.max === 'undefined'
  ) {
    return acc;
  }
  const {min, max} = option.range;
  values.push(
    `From $${min} to $${max}`,
    `Between $${min} to $${max}`,
    `$${min}-$${max}`,
  );
  acc.push(...values);
  return acc;
}, []);

const productGroupSuggestions = Object.values(productGroups)
  .filter(({value}) => value !== 'all')
  .map(({label}) => label);

const ageSuggestions = ['12 years old', '16 years old', '18 years old'];

const suggestions = [
  ...priceSuggestions,
  ...ageSuggestions,
  ...productGroupSuggestions,
];

export function getLocalSearchSuggestions(
  searchText: string,
): Array<{value: string; matchPos: number}> {
  const loweredSearchText = searchText.toLowerCase();
  const matches = [];
  for (const value of suggestions as string[]) {
    // needs to be improved - possibly using fuzzy matching
    const matchPos = value.toLowerCase().indexOf(loweredSearchText);
    if (matchPos >= 0) {
      matches.push({value, matchPos});
    }
  }
  return matches.sort((a, b) => a.matchPos - b.matchPos);
}
